<div class="flex h-screen">
  <app-sidebar></app-sidebar>
  <div class="ml-64 flex flex-1 flex-col overflow-hidden">
    <header
      class="flex h-14 shrink-0 items-center justify-end gap-3 border-b border-gray-200 bg-white px-4"
    >
      <app-notification-bell />
    </header>
    <main class="flex-1 overflow-y-auto">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>


